export default __webpack_public_path__ + "static/media/i2.2c17fd31.jpg";